import State from "slotworks/state-machine/states/state";
import Components from "slotworks/components/components";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";
import animateFromSceneToScene from "utils/animate-to-scene-config";
import Sequence from "slotworks/utils/contracts/sequence";
import mcRewardAnimation from "components/mc-reward-animation";
import Contract from "slotworks/utils/contracts/contract";
import substituteSymbols from "utils/substitute-symbols";
import smartUiFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import gameState from "slotworks/model/game-state";
import changeMatrixCommand from "commands/change-matrix-command";
import SpinReelTransition from "slotworks/components/matrix/reel/transition-behaviours/spin/spin-reel-transition";
import attachMcCountBehaviour from "utils/attach-mc-count-behaviour";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import Logger = require("js-logger");
import Layers from "slotworks/graphics/layers/layers";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import { Services } from "slotworks/services/services";
import Parallel from "slotworks/utils/contracts/parallel";
import { LLCustomLayers } from "names";

export class CGMCBonusExit extends State {
    public onEnter() {

        new Sequence([
            () => mcRewardAnimation.play(),
            () => Contract.wrap(() => Services.sound.customEvent("fortune_blast_music_outro")),
            () => this.tearDownBonus()
        ]).then(() => this.complete());
    }

    public tearDownBonus() {
        return new Sequence([
            () => new Parallel([
                () => Layers.Custom.get(LLCustomLayers.LOGOS).setScene("default"),
                () => Layers.Custom.get(LLCustomLayers.JACKPOTS).setScene("default")
            ]),
            () => Contract.wrap(() => {
                smartUiFlags.set(SmartUIFlag.FREE_SPINS, false);
                substituteSymbols.withRegularSymbols();
                Layers.MatrixBackground.setScene("default").execute();
                Layers.MatrixForeground.setScene("default").execute();
                Layers.Background.setScene("default").execute();
                Layers.Custom.get(LLCustomLayers.LOGOS).setScene("default").execute();
                changeMatrixCommand.trigger("default");
                Components.matrix.removeIndividualSymbolsMask();

                const transition = Components.matrix.getTransition() as SpinReelTransition;
                transition.stopGap = [370];

                lightningBorderAnimationUtil.stop();
                attachMcCountBehaviour.tearDownBehaviour();
                this.updateBonusResult();
                Components.betBar.setType(BetBarType.DEFAULT);
                // gameState.getCurrentGame().resetToRootRecord();
            }),

            // This delay is necessary because `Components.betBar.setType` triggers a transition which has a duration of
            // 500ms. After that transition completes, it refreshes the bet menu and stops any tweens in progress. Which
            // After the bonus is likely to be ticking up a big win.
            () => Contract.getTimeoutContract(600)
        ]);
    }

    private updateBonusResult() {
        const winnings = gameState.getCurrentGame().getCurrentRecord().cashWon;
        const bonusResult = this.getPickBonusByType("pick");
        const gatewayResult = this.getPickBonusByType("gateway");

        if (bonusResult && bonusResult.played === false) {
            bonusResult.played = true;
            bonusResult.cashWon = winnings;
        } else if (gatewayResult && gatewayResult.played === false) {
            gatewayResult.played = true;
            gatewayResult.cashWon = winnings;
        } else {
            Logger.log("No bonus result is available to be marked as played.");
        }
    }

    private getPickBonusByType(type: "gateway"|"pick") {
        const record = gameState.getCurrentGame().getRootRecord();
        return record.getResultsOfType(BonusResult).filter((result) => result.id === type).pop();
    }
}
